<template>
  <div class="main-slider-container">
    <call-to-action class="call-to-action-banner"></call-to-action>

    <div class="slider-wrapper">
      <carousel :autoplay="true"
                :autoplayTimeout="10000"
                :autoplayHoverPause="true"
                :perPage="1"
                :paginationEnabled="false"
                :navigationEnabled="true"
                :navigationClickTargetSize="20"
                :loop="true">
        <slide v-for="(slide, index) in slides" :key="index">
          <v-img :src="slide.image"
                 :alt="slide.alt"
                 class="slider-image"
                 gradient="to top, rgba(0,0,0,0.4), rgba(0,0,0,0.2)">
            <div class="slider-content-wrapper">
              <div class="slider-overlay-content">
                <h1 class="slider-title earthwerk-font">Discover Ol Pejeta</h1>
                <p class="slider-subtitle">Experience Kenya's wildlife wonderland</p>
              </div>

              <div class="search-position">
                <search id="search-component" class="search-box"></search>
              </div>
            </div>
          </v-img>
        </slide>

        <template slot="prevButton">
          <button class="v-carousel-control v-carousel-control--prev">
            <v-icon dark>chevron_left</v-icon>
          </button>
        </template>

        <template slot="nextButton">
          <button class="v-carousel-control v-carousel-control--next">
            <v-icon dark>chevron_right</v-icon>
          </button>
        </template>
      </carousel>
    </div>
  </div>
</template>

<script>
  import Search from './Search.vue'
  import CallToAction from './CallToAction.vue'

  export default {
    name: 'PublicMainSlider',
    components: {
      CallToAction,
      Search
    },
    data() {
      return {
        slides: [
          { image: require('@/assets/Public/banners/elephants.jpg'), alt: 'Elephants in the wild' },
          { image: require('@/assets/Public/banners/lioness.jpg'), alt: 'Lioness on the hunt' },
          { image: require('@/assets/Public/banners/secretary.jpg'), alt: 'Secretary bird' },
          { image: require('@/assets/Public/banners/zebra.jpg'), alt: 'Zebra herd' }
        ]
      }
    }
  }
</script>

<style scoped>
  @font-face {
    font-family: 'Earthwerk';
    src: url('PizzaDude.dk-Earthwerk.otf') format('opentype');
    font-weight: normal;
    font-style: normal;
  }

  .main-slider-container {
    position: relative;
    width: 100%;
    overflow: hidden;
  }

  .call-to-action-banner {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    z-index: 10;
  }

  .slider-wrapper {
    position: relative;
    width: 100%;
    margin-top: 60px; /* Space for call-to-action banner */
  }

  .slider-image {
    width: 100%;
    height: calc(90vh - 60px); /* Adjust height accounting for banner */
    min-height: 600px;
    object-fit: cover;
  }

  .slider-content-wrapper {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .slider-overlay-content {
    padding: 40px;
    color: white;
    text-shadow: 1px 1px 3px rgba(0,0,0,0.5);
    max-width: 800px;
    margin-top: 40px; /* Push content down below call-to-action */
  }

  .earthwerk-font {
    font-family: 'Earthwerk', sans-serif;
    font-size: 3.5rem;
    line-height: 1.1;
    margin-bottom: 1rem;
  }

  .slider-title {
    font-size: 3.5rem;
    font-weight: bold;
    color: white;
  }

  .slider-subtitle {
    font-size: 1.5rem;
    font-weight: 300;
    color: white;
    margin-bottom: 2rem;
  }

  .search-position {
    width: 100%;
    padding: 0 40px 60px;
  }

  .search-box {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
  }

  /* Carousel navigation buttons */
  .v-carousel-control {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 50px;
    height: 50px;
    background: rgba(0,0,0,0.3);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: 5;
    transition: all 0.3s ease;
    border: none;
    outline: none;
  }

    .v-carousel-control:hover {
      background: rgba(0,0,0,0.5);
    }

  .v-carousel-control--prev {
    left: 20px;
  }

  .v-carousel-control--next {
    right: 20px;
  }

  /* Responsive adjustments */
  @media (max-width: 1200px) {
    .slider-overlay-content {
      max-width: 70%;
    }

    .slider-image {
      height: calc(85vh - 60px);
    }
  }

  @media (max-width: 960px) {
    .slider-image {
      height: calc(80vh - 60px);
      min-height: 500px;
    }

    .slider-overlay-content {
      padding: 30px;
      max-width: 80%;
      margin-top: 30px;
    }

    .slider-title {
      font-size: 2.8rem;
    }

    .slider-subtitle {
      font-size: 1.3rem;
    }

    .search-position {
      padding: 0 30px 50px;
    }

    .v-carousel-control {
      width: 40px;
      height: 40px;
    }
  }

  @media (max-width: 600px) {
    .slider-wrapper {
      margin-top: 50px; /* Less space for mobile */
    }

    .slider-image {
      height: calc(70vh - 50px);
      min-height: 450px;
    }

    .slider-overlay-content {
      padding: 20px;
      max-width: 90%;
      margin-top: 20px;
    }

    .slider-title {
      font-size: 2.2rem;
    }

    .slider-subtitle {
      font-size: 1.1rem;
    }

    .search-position {
      padding: 0 20px 40px;
    }

    .v-carousel-control {
      width: 36px;
      height: 36px;
    }
  }
</style>
